import React from "react";
import { Dropdown } from "antd";
import {
  EditOutlined,
  EyeOutlined,
  LinkOutlined,
  QrcodeOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import styles from "./BusinessMenu.module.css";

const MENU_ITEMS = [
  { key: "edit", icon: <EditOutlined />, label: "Edit Business" },
  { key: "preview", icon: <EyeOutlined />, label: "Preview" },
  { key: "qrCode", icon: <QrcodeOutlined />, label: "QR Code" },
  { key: "copyLink", icon: <LinkOutlined />, label: "Copy Link" },
  { type: "divider" },
  { key: "delete", icon: <DeleteOutlined />, label: "Delete", danger: true },
];

const BusinessMenu = React.memo(function BusinessMenu({ onAction }) {
  const items = MENU_ITEMS.map((item) => {
    if (item.type === "divider") return { type: "divider" };
    return {
      key: item.key,
      icon: item.icon,
      label: item.label,
      danger: item.danger,
    };
  });

  return (
    <Dropdown
      menu={{
        items,
        onClick: ({ key, domEvent }) => {
          domEvent?.stopPropagation?.();
          onAction?.(key);
        },
      }}
      trigger={["click"]}
      placement="bottomRight"
      overlayClassName={styles.dropdown}
    >
      <button
        className={styles.trigger}
        onClick={(e) => e.stopPropagation()}
        aria-label="Business actions"
      >
        <svg width="15" height="15" viewBox="0 0 15 15" fill="currentColor">
          <circle cx="7.5" cy="3" r="1.5" />
          <circle cx="7.5" cy="7.5" r="1.5" />
          <circle cx="7.5" cy="12" r="1.5" />
        </svg>
      </button>
    </Dropdown>
  );
});

export default BusinessMenu;
